import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringDraftRestorePoints = api(async function getAuthoringDraftRestorePoints({
    projectId,
    scheduleId,
}) {
    if (!projectId || !scheduleId) return []
    return query(
        gql`
            query GetAuthoringDraftRestorePoints($projectId: String!, $scheduleId: String!) {
                getAuthoringDraftRestorePoints(projectId: $projectId, scheduleId: $scheduleId)
            }
        `,
        { projectId, scheduleId },
        { returns: "getAuthoringDraftRestorePoints" }
    )
})
